import service from './../service.js';

export default {
    add(uuid, type, score, remarks) {
        return service.post('/support/' + uuid + '/rating', {
            type: type,
            score: score,
            remarks: remarks,
        });
    },
}